import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
	createDownDayPMOrders,
	UpdateTaskListPriority,
} from "../repositorie/TaskListRepositorie";
import { TASK_LIST_QUERY_KEYS } from "./useTaskListQueries";

type Options = {
	onSuccess?: () => void;
	onError?: (error: Error) => void;
};

export const useUpdateTaskListPriority = ({
	onSuccess,
	onError,
}: Options = {}) => {
	const queryClient = useQueryClient();
	const mutation = useMutation({
		mutationFn: (vars: {
			WorkOrderIdToMove: number;
			WorkOrderIdMoveBelow: number | null;
			TargetCategory: string | null;
		}) =>
			UpdateTaskListPriority(
				vars.WorkOrderIdToMove,
				vars.WorkOrderIdMoveBelow,
				vars.TargetCategory,
			),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: TASK_LIST_QUERY_KEYS.all });
			onSuccess?.();
		},
		onError: (error: Error) => onError?.(error),
	});

	return {
		updatePriority: mutation.mutate,
		isUpdating: mutation.isLoading,
	};
};

export const useCreateDownDayPMOrders = ({
	onSuccess,
	onError,
}: Options = {}) => {
	const queryClient = useQueryClient();
	const mutation = useMutation({
		mutationFn: (vars: {
			assetId: number | string | null;
			templateIds: number[] | null;
			downDayCode: string | null;
		}) =>
			createDownDayPMOrders(vars.assetId, vars.templateIds, vars.downDayCode),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: TASK_LIST_QUERY_KEYS.all });
			onSuccess?.();
		},
		onError: (error: Error) => onError?.(error),
	});

	return {
		createDownDayPMOrders: mutation.mutate,
		isCreating: mutation.isLoading,
	};
};
